export enum ForgotPassword {
  REQUEST_RESET_CODE = 'RequestResetPasswordCodeEvent',
  REQUEST_RESET_CODE_SUCCESS = 'RequestResetPasswordCodeSuccessEvent',
  REQUEST_RESET_CODE_FAILURE = 'RequestResetPasswordCodeFailureEvent',
  SUBMIT_RESET_CODE = 'SubmitResetPasswordCodeEvent'
}
